import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferProgramDto } from '../Types/offerProgramTypes';

export const offerProgramApi = createGenericApiSlice<OfferProgramDto>({
  reducerPath: 'offerProgramApi',
  tag: TagTypes.OfferProgram,
  endpoint: 'offer-program',
});

export const {
  useGetAllQuery: useGetOfferProgramsQuery,
  useGetByIdQuery: useGetOfferProgramByIdQuery,
  useCreateMutation: useCreateOfferProgramMutation,
  useUpdateMutation: useUpdateOfferProgramMutation,
  useDeleteMutation: useDeleteOfferProgramMutation,
} = offerProgramApi;
